'use client';
import { useShareResult } from '@/lib/gameShare';

export function GridShareButton({ grid }: { grid: string }) {
  const { share, copied } = useShareResult('grid', grid);
  return (
    <button
      type="button"
      onClick={share}
      style={{
        padding: '10px 18px',
        border: 'none',
        borderRadius: 0,
        background: 'var(--coral-deep)',
        color: '#fff',
        fontFamily: 'var(--font-expanded)',
        fontWeight: 700,
        fontSize: 13,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        cursor: 'pointer',
      }}
    >
      {copied ? 'Copied!' : 'Share result'}
    </button>
  );
}
